"use client";

import { usePathname } from "next/navigation";
import { useState, useEffect } from "react";
import DocsSidebar from "./components/DocsSidebar";
import DocsHeader from "./components/DocsHeader";
import DocsFooter from "./components/DocsFooter";

export default function DocumentationLayoutClient({ children }) {
  const pathname = usePathname();
  const isRootPage = pathname === "/documentation";
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isMobileMenuOpen]);

  if (isRootPage) {
    return <div className="docs-site docs-landing">{children}</div>;
  }

  return (
    <div className="docs-site min-h-screen bg-white flex">
      <DocsSidebar
        isMobileMenuOpen={isMobileMenuOpen}
        onClose={() => setIsMobileMenuOpen(false)}
      />

      <div className="docs-workspace flex-1 lg:ml-64 flex flex-col min-h-screen">
        <DocsHeader
          isMobileMenuOpen={isMobileMenuOpen}
          onToggleMenu={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        />

        <main className="flex-1 flex flex-col">
          <div className="mx-auto px-4 sm:px-6 lg:px-8 w-full flex-1 flex flex-col">
            {children}
          </div>
          <DocsFooter />
        </main>
      </div>
    </div>
  );
}
